import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {NgxSpinnerService} from 'ngx-spinner';

import {BehaviorSubject, EMPTY, firstValueFrom} from 'rxjs';
import {first} from 'rxjs/operators';

import {BaseFormComponent, FormManagerService} from '@sim/form';

import {Media, MediaMeta} from '../../models/media';
import {MediaService} from '../../services/media.service';

interface State {
  filesToUpload: File[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-media-manager',
  styleUrls: ['./media-manager.component.scss'],
  templateUrl: './media-manager.component.html',
})
export class MediaManagerComponent extends BaseFormComponent<Media> {

  state$ = new BehaviorSubject<State>({
    filesToUpload: [],
  });

  get state() {
    return this.state$.value;
  }

  constructor(
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly route: ActivatedRoute,
    protected readonly formManager: FormManagerService,
    protected readonly spinner: NgxSpinnerService,
    private readonly mediaApi: MediaService,
  ) {
    super(snackBarService, translate, route, formManager, spinner, undefined, MediaMeta);
  }

  addConcrete() {
    return EMPTY;
  }

  removeConcrete() {
    return EMPTY;
  }

  editConcrete() {
    return EMPTY;
  }

  resetFormConcrete() {
    return EMPTY;
  }

  deleteSelectHandler(media: File[]) {
    const mediaNames = media.map((m) => m.name);
    const files = this.state.filesToUpload;

    const remainedFiles = files.filter((f) => !mediaNames.includes(f.name));

    this.setState({filesToUpload: remainedFiles});
  }

  loadMediaHandler(media: File[]) {
    const files = this.state.filesToUpload;

    this.setState({filesToUpload: [...files, ...media]});
  }

  async uploadHandler(fileList: File[]) {
    await firstValueFrom(this.mediaApi.post(fileList).pipe(first()));

    const filesToUpload = this.state.filesToUpload.filter((f) => !fileList.some((fi) => fi.name === f.name));

    this.setState({filesToUpload});
  }

  private setState(state: Partial<State>) {
    this.state$.next({...this.state, ...state});
  }
}
